<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <button
        class="button is-addOrEdit is-pulled-right"
        @click="ajouter()">
        {{ $t('general.button.add') }}
      </button>
    </div>
    <div class="column is-1">
    </div>
    <div class="column is-11">
      <v-client-table
        class="displayNonePagination"
        :data="ligne.lieuxLivraisons"
        :columns="columns"
        :options="options">
        <template #lieux="{ row, index }">
          <tiers-autocomplete
            v-model="row.lieuDeLivraison"
            :societeActiveId="societeActiveId"
            :type="TIERS_TYPE_FOURNISSEUR"
            :sousTypes="[TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON]"
            @input="(e) => changeLieu(e, index)"
            openOnFocus>
            <template slot-scope="{ option }">
              <p>
                <span v-if="option.code">{{ option.code }} </span>
                <span>{{ option.nomCommercial }}</span>
              </p>
            </template>
          </tiers-autocomplete>
        </template>
        <template #quantite="{ row, index }">
          <b-input :value="row.quantite" @input="e => setQuantite(e , index)"></b-input>
        </template>
        <template #delete="{ index }">
          <a @click="supprimer(index)">
            <b-icon icon="delete-forever" type="is-danger">
            </b-icon>
          </a>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';
import tiersAutocomplete from '@/components/general/autocomplete/tiersAutocomplete';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON } from '@/configuration/tiers/tiersConf';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
  },
  components: {
    tiersAutocomplete,
  },
  data() {
    return {
      TIERS_TYPE_FOURNISSEUR,
      TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      return ['lieux', 'quantite', 'delete'];
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      return {
        texts,
        headings: {
          lieux: this.$t('addEditCommande.lieuLivraison.table.lieuLivraison'),
          quantite: this.$t('addEditCommande.lieuLivraison.table.quantite'),
          delete: '',
        },
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPage: tableConfig.RESULTS_PER_PAGE,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        sortable: [],
        columnsClasses: {
          lieux: 'min250px',
          quantite: 'colonneWith180',
          delete: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    genererLieuxLivraison(ligne) {
      return {
        ligneCommandeId: ligne.id,
        lieuDeLivraison: null,
        lieuDeLivraisonId: null,
        quantite: 0,
      };
    },
    ajouter() {
      if (!this.ligne.lieuxLivraisons) {
        this.ligne.lieuxLivraisons = [];
      }
      const lieux = cloneDeep(this.ligne.lieuxLivraisons);
      lieux.push(this.genererLieuxLivraison(this.ligne));
      this.$set(this.ligne, 'lieuxLivraisons', lieux);
    },
    supprimer(index) {
      this.ligne.lieuxLivraisons.splice(index - 1, 1);
    },
    setQuantite(value, index) {
      this.$set(this.ligne.lieuxLivraisons[index - 1], 'quantite', value);
    },
    changeLieu(value, index) {
      this.$set(this.ligne.lieuxLivraisons[index - 1], 'lieuDeLivraison', value);
      this.$set(this.ligne.lieuxLivraisons[index - 1], 'lieuDeLivraisonId', value?.id ?? null);
    },
  },
};
</script>

<style>

</style>
